import { useMemo } from "react";
import { Place } from "../../types/place";
import { initMetadata } from "../../controllers/formController";
import { SystemEntityProofreadingStatus } from "../../shared/enums/shared-enums";

const usePlaceLogic = () => {
  const placeCulturalSphereEnum = useMemo<string>(
    () => "place_cultural_sphere",
    []
  );
  const placeLinksTypeEnum = useMemo<string>(() => "place_links_type", []);
  const placeTypeEnum = useMemo<string>(() => "place_type", []);
  const regionCountryAreasEnum = useMemo<string>(
    () => "region_country_areas",
    []
  );

  const userEnums = useMemo<string[]>(
    () => [
      placeCulturalSphereEnum,
      placeLinksTypeEnum,
      placeTypeEnum,
      regionCountryAreasEnum,
    ],
    [
      placeCulturalSphereEnum,
      placeLinksTypeEnum,
      placeTypeEnum,
      regionCountryAreasEnum,
    ]
  );

  const metadataFieldNames = useMemo<Array<keyof Place>>(
    () => [
      "other_designations",
      "cultural_sphere",
      "external_links",
      "region",
      "type",
    ],
    []
  );

  const defaultPlace = useMemo<Place>(() => {
    return {
      _id: "",
      _rev: "",
      _key: "",
      name: "",
      published_id: "",
      other_designations: [],
      cultural_sphere: "",
      external_links: [],
      region: { parent: "", child: "" },
      type: "",
      notes: "",
      internal_notes: "",
      entity_status_of_proofreading:
        SystemEntityProofreadingStatus.NOT_PROOFREAD,
      attributes_metadata: initMetadata<Place>(metadataFieldNames),
    };
  }, [metadataFieldNames]);

  const getDisplayName = (place?: Place | null): string => {
    const displayName =
      (place?.name || place?.published_id ? `: ` : "") +
      place?.published_id +
      (place?.published_id && place?.name ? " - " : "") +
      place?.name;
    return `Place${displayName}`;
  };
  return {
    userEnums,
    metadataFieldNames,
    defaultPlace,
    getDisplayName,
    placeCulturalSphereEnum,
    placeLinksTypeEnum,
    placeTypeEnum,
    regionCountryAreasEnum,
  };
};

export default usePlaceLogic;
